<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

Vue.component("apexchart", VueApexCharts);

export default {
  name: "FixedBarChart",
  props: {
    data: {
      type: [Array],
      required: false,
    },
  },
  data() {
    return {
      series: [
        {
          name: "Cantidad",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 450,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "60%",
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
          labels: {
            rotate: -45,
            style: {
              fontSize: "11px",
            },
          },
        },
        yaxis: {
          title: {
            text: "Total",
          },
        },
        tooltip: {
          y: {
            formatter: (val) => `${val} unidades`,
          },
        },
      },
    };
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newData) {
        if (Array.isArray(newData)) {
          this.series = [
            {
              name: "Cantidad",
              data: newData.map((item) => item.data),
            },
          ];

          this.chartOptions.xaxis.categories = newData.map(
            (item) => item.label
          );
        }
      },
    },
  },
};
</script>

<template>
  <div class="bg-white p-8 border-[1px] border-primary shadow-md rounded-xl">
    <h1 class="!text-xl !font-bold text-left">
      Cantidad de despachos por pedidor
    </h1>
    <div class="mt-4">
      <apexchart
        v-if="data && data.length > 0"
        width="100%"
        height="450"
        type="bar"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>
